import type { ReactNode } from "react";

type AdminFilterPanelProps = {
  children: ReactNode;
};

export function AdminFilterPanel({ children }: AdminFilterPanelProps) {
  return (
    <div className="admin-filter-panel" aria-label="絞り込み条件">
      {children}
    </div>
  );
}
